import React, { useEffect, useState } from "react";
import { Card } from "@material-tailwind/react";
import { useMutation } from "@tanstack/react-query";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPut, fetchPostMultipartSeaweed } from "../../../fetchers";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ALLOWED_NIKS = ["HO-20250504", "222"];

const EditAttachmentPurchaseRequisitionPage = () => {
  const navigate = useNavigate();
  const { bu, id } = useParams();
  const transid = id ? id.replaceAll("-", "/") : "";

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (!user || !ALLOWED_NIKS.includes(user.Nik)) {
      navigate(-1);
    }
  }, []);

  const [currentFile, setCurrentFile] = useState("");
  const [newFile, setNewFile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const mutationFile = useMutation((formData) =>
    fetchPostMultipartSeaweed(formData)
  );

  const mutationUpdate = useMutation((formData) =>
    fetchPut("Procurement/PurchaseRequisition/file", formData)
  );

  useEffect(() => {
    if (!transid) return;
    fetchGet("Procurement/PurchaseRequisition/" + transid)
      .then((res) => {
        if (res?.data?.NamaFile) {
          setCurrentFile(res.data.NamaFile);
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [transid]);

  const handleSubmit = async () => {
    if (!newFile) {
      toast.error("Pilih file terlebih dahulu", { position: "top-center", autoClose: 2000 });
      return;
    }

    setIsSubmitting(true);
    try {
      const { v4: uuidv4 } = require("uuid");
      const uuid = uuidv4();
      const formData = new FormData();
      const nama = uuid + "-" + newFile.name.replaceAll(" ", "_");
      formData.append("file", newFile, nama);
      mutationFile.mutate(formData);

      mutationUpdate.mutate(
        { PurchaseRequisitionID: transid, NamaFile: nama },
        {
          onSuccess: () => {
            toast.success("Attachment berhasil diperbarui", {
              position: "top-center",
              autoClose: 1500,
            });
            setTimeout(() => navigate(-1), 1600);
          },
          onError: () => {
            setIsSubmitting(false);
          },
        }
      );
    } catch (err) {
      toast.error("Gagal mengupload file", { position: "top-center", autoClose: 2000 });
      setIsSubmitting(false);
    }
  };

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full" />
      </div>

      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col mt-5 p-6">
                <div className="flex w-full justify-between items-center mb-6">
                  <h2 className="text-lg font-bold text-gray-700">Edit Attachment MSR</h2>
                  <button
                    onClick={() => navigate(-1)}
                    className="flex flex-row items-center justify-center bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                </div>

                {isLoading ? (
                  <div className="text-gray-500">Memuat data...</div>
                ) : (
                  <div className="flex flex-col gap-4 max-w-lg">
                    <div>
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">
                        No. MSR
                      </label>
                      <div className="text-sm text-gray-800">{transid}</div>
                    </div>

                    <div>
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">
                        File Saat Ini
                      </label>
                      <div className="text-sm text-gray-600">
                        {currentFile || "Tidak ada file"}
                      </div>
                    </div>

                    <div>
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                        Upload File Baru
                      </label>
                      <label className="flex flex-row items-center cursor-pointer border border-gray-300 rounded px-4 py-2 hover:bg-gray-50 w-full">
                        <span className="text-sm text-gray-700 flex-1">
                          {newFile ? newFile.name : "Pilih file..."}
                        </span>
                        <span className="text-xs text-main-100 font-semibold ml-2">Browse</span>
                        <input
                          type="file"
                          className="hidden"
                          onChange={(e) => setNewFile(e.target.files[0] || null)}
                        />
                      </label>
                    </div>

                    <div className="flex gap-3 mt-4">
                      <button
                        onClick={handleSubmit}
                        disabled={isSubmitting || !newFile}
                        className="text-white bg-main-100 hover:opacity-90 disabled:opacity-50 font-medium rounded-lg text-sm px-6 py-2"
                      >
                        {isSubmitting ? "Menyimpan..." : "Simpan"}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditAttachmentPurchaseRequisitionPage;
